import classNames from 'classnames';
import React from 'react';
import styles from './TopOverlay.module.scss';

export interface TopOverlayProps {
  leftChildren?: React.ReactNode;
  rightChildren?: React.ReactNode;
  className?: string;
  baseClassName?: string; // for passing .base if needed
}

export const TopOverlay: React.FC<TopOverlayProps> = ({
  leftChildren,
  rightChildren,
  className,
  baseClassName,
}) => (
  <div className={classNames(styles.topOverlay, className)}>
    {leftChildren && (
      <div className={classNames(styles.upperLeft, baseClassName)}>{leftChildren}</div>
    )}
    {rightChildren && (
      <div className={classNames(styles.upperRight, baseClassName)}>{rightChildren}</div>
    )}
  </div>
);
